import { Box, Link, Stack, Typography } from '@mui/material';
import { UfoIcon } from '../UfoIcon';

interface OopsSomethingWentWrongProps {
  onDataRefresh?: () => void;
  buttonLabel?: string;
}

export function OopsSomethingWentWrong({
  onDataRefresh,
  buttonLabel = 'Refresh the Query',
}: OopsSomethingWentWrongProps) {
  return (
    // Box required to avoid overriding of Stack margin
    <Box>
      <Stack
        direction="row"
        spacing={10}
        justifyContent="center"
        alignItems="center"
        mt={7}
      >
        <Stack alignItems="flex-start" spacing={1}>
          <Typography variant="h4">
            <Box>Oops!</Box>
            <Box>Something went wrong</Box>
          </Typography>
          <Typography variant="caption">
            <Box>Brace yourself till we get the error fixed.</Box>
            <Box>You can refresh the page or hit the link below.</Box>
          </Typography>
          {!!onDataRefresh && (
            <Link
              component="button"
              variant="subtitle1"
              onClick={onDataRefresh}
            >
              {buttonLabel}
            </Link>
          )}
        </Stack>
        <UfoIcon width={269} />
      </Stack>
    </Box>
  );
}
